import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { LoadingOverlay, Stack } from '@mantine/core';

import { useMenusPageAccess } from '@/hooks/useMenusPageAccess';
import { HEADER_HEIGHT, ROUTES } from '@/constants';

type MenusPermissionRouteProps = {
  children: ReactNode;
};

const MenusPermissionRoute: React.FC<MenusPermissionRouteProps> = ({ children }) => {
  const { hasAccess, loading } = useMenusPageAccess();

  if (loading) {
    return (
      <Stack align="center" justify="center" style={{ height: '100%' }}>
        <LoadingOverlay visible top={HEADER_HEIGHT} />
      </Stack>
    );
  }

  if (!hasAccess) {
    return <Navigate to={ROUTES.root} replace />;
  }

  return <>{children}</>;
};

export default MenusPermissionRoute;
